import { render, staticRenderFns } from "./CategoryChildComponent.vue?vue&type=template&id=68210ad4&scoped=true"
import script from "./CategoryChildComponent.vue?vue&type=script&lang=js"
export * from "./CategoryChildComponent.vue?vue&type=script&lang=js"
import style0 from "./CategoryChildComponent.vue?vue&type=style&index=0&id=68210ad4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68210ad4",
  null
  
)

export default component.exports